exports.default = "<div class=\"we_ADs\"> </div>";